
import { Component, Mixins, Prop, Watch} from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";
import { BillToResource } from "@/models/api/barcodeSystem/billTos/get";

const barcodeCompanyModuleState = getModule(BarcodeCompanyModule);

@Component({
  components: {
    Select
  }
})
export default class BarcodeBillToSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop()
  type: string;
  @Prop({ default: null })
  companyIds: number[];
  localBillTos: BillToResource[] = null;

  get billTos()
  {
    return barcodeCompanyModuleState.billTos;
  }

  created() {
    this.localBillTos = JSON.parse(JSON.stringify(this.billTos));
  }

  get types() {
    if(this.companyIds && this.companyIds.length > 0)
      return this.localBillTos.filter(x => this.companyIds.includes(x.companyId)).map(x => ({ label: x.agentCompanyId ?? x.billToCompanyId, value: x.billToCompanyId }));
    else
      return this.localBillTos.map(x => ({ label: x.agentCompanyId ?? x.billToCompanyId, value: x.billToCompanyId }));
  }
}
